import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import type { IVulnsCount } from "./types";

import { GET_VULNS_COUNT } from "../queries";
import type {
  GetVulnsCountQueryVariables,
  GetVulnsQueryVariables,
} from "gql/graphql";
import { useAudit } from "hooks/use-audit";

const useGetVulnsCountQuery = ({
  findingId,
  first,
  filters,
}: GetVulnsCountQueryVariables): IVulnsCount => {
  const { addAuditEvent } = useAudit();
  const { data, loading, error } = useQuery(GET_VULNS_COUNT, {
    fetchPolicy: "no-cache",
    onCompleted: (): void => {
      addAuditEvent("Finding.Vulnerabilities", findingId);
    },
    variables: {
      filters: filters as unknown as GetVulnsQueryVariables["filters"],
      findingId,
      first,
    },
  });

  const total = useMemo((): number => {
    return data?.finding.vulnerabilities
      ? (data.finding.vulnerabilities.total ?? 0)
      : 0;
  }, [data]);

  return {
    error,
    loading,
    total,
  };
};

export { useGetVulnsCountQuery };
